import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { toggleSidebar } from '../../store'
import { Menu, Image } from 'semantic-ui-react'
import { MenuProps } from './ResponsiveMenu'

interface HeaderMenuProps extends MenuProps {
  dispatch?: Dispatch<any>
  inverted?: boolean
}

export const HeaderMenu = ({ items, pathname, Link, inverted, dispatch }: HeaderMenuProps) =>
    <Menu fixed='top' size='large' className='lime' secondary inverted={inverted}>
      <Menu.Item to='/' as={Link} fitted>
        <Image
          size='tiny'
          src='//res.cloudinary.com/danrx4fes/image/upload/c_fit,w_257,h_73/logo'
          alt='G&amp;A Arquitetura e Engenharia' />
      </Menu.Item>
      <Menu.Menu position='right'>
        <Menu.Item as='a'
          className='mobile only'
          icon='sidebar'
          onClick={() => dispatch && dispatch(toggleSidebar())} />
        {items.map((item) => {
          const active = (item.exact) ? pathname === item.path : pathname.startsWith(item.path)
          return <Menu.Item
            as={Link}
            className='mobile hidden'
            content={item.name}
            name={item.name}
            to={item.path}
            key={item.path}
            active={active}
          />
        })}
      </Menu.Menu>
    </Menu>

export default connect()(HeaderMenu)
